import { useRequiredParams } from '@pba/react-router';
import { GuestLayout } from 'layouts';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import { PublicCommunityAboutContent, PublicCommunityLayout } from 'features/communities';

const PagePublicCommunityAbout = () => {
  const { communityId } = useRequiredParams<{ communityId: string }>();
  const navigate = useNavigate();

  const joinCommunity = async () => {
    await navigate(routes.signUp, {
      state: {
        join_community_id: communityId,
        referrer: window.location.pathname,
      },
    });
  };

  return (
    <GuestLayout>
      <PublicCommunityLayout communityId={communityId}>
        {(community) => <PublicCommunityAboutContent community={community} joinCommunity={joinCommunity} />}
      </PublicCommunityLayout>
    </GuestLayout>
  );
};

export default PagePublicCommunityAbout;
